import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExaMaterialModule } from 'app/main/modules/examaterial.module';
import { DialogConfermaInformativaComponent } from 'app/main/utils/dialog/dialog-conferma-informativa/dialog-conferma-informativa.component';
import { DialogConfermaComponent } from 'app/main/utils/dialog/dialog-conferma/dialog-conferma.component';
import { DialogEliminaComponent } from 'app/main/utils/dialog/dialog-elimina/dialog-elimina.component';
import { DialogNonDisponibileAppComponent } from 'app/main/utils/dialog/dialog-non-disponibile-app/dialog-non-disponibile-app.component';
import { DialogStampaContent } from 'app/main/utils/dialog/dialog-stampa/dialog-stampa.component';
import { DialogVisualizzaPdfComponent } from 'app/main/utils/dialog/dialog-visualizza-pdf/dialog-visualizza-pdf.component';
import { ClickStopPropagation } from 'app/directives/click-stop-propagation.directive';
import { SafePipe } from 'app/main/utils/pipes/safe.pipe';
import { FuseIfOnDomDirective } from './directives/fuse-if-on-dom/fuse-if-on-dom.directive';
import { FuseInnerScrollDirective } from './directives/fuse-inner-scroll/fuse-inner-scroll.directive';
import {
  FuseMatSidenavHelperDirective,
  FuseMatSidenavTogglerDirective
} from './directives/fuse-mat-sidenav/fuse-mat-sidenav.directive';
import { FusePerfectScrollbarDirective } from './directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { DialogUploadFotoProfiloComponent } from 'app/main/utils/dialog/dialog-upload-foto-profilo/dialog-upload-foto-profilo.component';

@NgModule({
  imports: [
    CommonModule,
    DialogConfermaComponent,
    DialogConfermaInformativaComponent,
    DialogEliminaComponent,
    DialogStampaContent,
    DialogUploadFotoProfiloComponent,
    DialogVisualizzaPdfComponent,
    DialogNonDisponibileAppComponent,
    ClickStopPropagation,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    FuseIfOnDomDirective,
    FuseInnerScrollDirective,
    FuseMatSidenavHelperDirective,
    FuseMatSidenavTogglerDirective,
    FusePerfectScrollbarDirective,
    SafePipe,
    ExaMaterialModule
  ],
  exports: [
    CommonModule,
    ClickStopPropagation,
    FormsModule,
    ReactiveFormsModule,
    ExaMaterialModule,
    FlexLayoutModule,

    FuseIfOnDomDirective,
    FuseInnerScrollDirective,
    FuseMatSidenavHelperDirective,
    FuseMatSidenavTogglerDirective,
    FusePerfectScrollbarDirective,
    SafePipe,
    DialogConfermaComponent,
    DialogConfermaInformativaComponent,
    DialogEliminaComponent,
    DialogStampaContent,
    DialogUploadFotoProfiloComponent,
    DialogVisualizzaPdfComponent,
    DialogNonDisponibileAppComponent
  ]
})
export class FuseSharedModule {}
